(function () {
  'use strict';
  function deliveryEstimate({ personalisedOnly, subtotal, rates, currency }) {
    if (!personalisedOnly || currency !== 'GBP' || !Number.isSafeInteger(subtotal) || subtotal < 0 || !Array.isArray(rates)) return null;
    // A successful UK-address rate lookup alone is not evidence of a personalised service.
    const supported = rates.some(rate => /^personali[sz]ed\b/i.test(String(rate.name || '')) && /^\d+(\.\d{1,2})?$/.test(String(rate.price)) &&
      [0, 625].includes(Math.round(Number(rate.price) * 100)) && (!rate.currency || rate.currency === 'GBP'));
    return supported ? (subtotal >= 15000 ? 0 : 625) : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { deliveryEstimate };
  if (typeof document === 'undefined') return;
  function reset(root) {
    root.querySelectorAll('[data-ffc-ux-estimated-delivery], [data-ffc-ux-estimated-total]').forEach(row => { row.hidden = true; });
    root.querySelector('[data-ffc-ux-delivery-fallback]').hidden = false;
  }
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-ffc-ux-postcode]')) return;
    const root = event.target.closest('[data-ffc-ux-summary]');
    root.dataset.quoteVersion = String(Number(root.dataset.quoteVersion || 0) + 1);
    reset(root);
    root.querySelector('[data-ffc-ux-estimate-status]').textContent = '';
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ffc-ux-estimate]');
    if (!button || button.disabled) return;
    const root = button.closest('[data-ffc-ux-summary]');
    const status = root.querySelector('[data-ffc-ux-estimate-status]');
    const postcode = root.querySelector('[data-ffc-ux-postcode]').value.trim().toUpperCase();
    reset(root);
    status.textContent = status.dataset.fallback;
    if (root.dataset.personalisedOnly !== 'true' || !/^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/.test(postcode)) return;
    const version = root.dataset.quoteVersion || '0';
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    button.disabled = true;
    status.textContent = status.dataset.loading;
    try {
      const url = new URL(root.dataset.ratesUrl, window.location.origin);
      url.searchParams.set('shipping_address[country]', 'United Kingdom');
      url.searchParams.set('shipping_address[zip]', postcode);
      const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) throw new Error('Rate unavailable');
      const data = await response.json();
      if (!root.isConnected || (root.dataset.quoteVersion || '0') !== version) return;
      const subtotal = Number(root.dataset.subtotal);
      const charge = deliveryEstimate({ personalisedOnly: true, subtotal, rates: data.shipping_rates, currency: 'GBP' });
      if (charge === null) throw new Error('Personalised service unavailable');
      const money = value => new Intl.NumberFormat('en-GB', { style:'currency', currency:'GBP' }).format(value / 100);
      root.querySelector('[data-ffc-ux-delivery-value]').textContent = money(charge);
      root.querySelector('[data-ffc-ux-total-value]').textContent = money(subtotal + charge);
      root.querySelectorAll('[data-ffc-ux-estimated-delivery], [data-ffc-ux-estimated-total]').forEach(row => { row.hidden = false; });
      root.querySelector('[data-ffc-ux-delivery-fallback]').hidden = true;
      status.textContent = status.dataset.estimated;
    } catch (_) {
      if (root.isConnected && (root.dataset.quoteVersion || '0') === version) status.textContent = status.dataset.fallback;
    } finally {
      window.clearTimeout(timeout);
      button.disabled = false;
    }
  });
}());
